import React from 'react';
import { Grid3X3 } from 'lucide-react';

const StrategyPlaceholder = () => {
  return (
    <div className="bg-card text-card-foreground rounded-lg shadow-sm border border-border p-6">
      <div className="flex flex-col items-center justify-center py-6 text-center">
        <Grid3X3 className="w-8 h-8 text-muted-foreground/40 mb-3" />
        <h3 className="text-sm font-semibold text-foreground">Strategy Tracker</h3>
        <p className="text-xs text-muted-foreground mt-1">Coming soon — track and compare your trading strategies</p>
      </div>
    </div>
  );
};

export default StrategyPlaceholder;
